<div nz-col [nzSpan]="24" [class.loading]="loading">
  <nz-spin [nzSpinning]="loading">
    <div class="matches-list m-b-16">
      <div *ngFor="let talent of matches.items" class="matches-item" [class.matches-item--favourite]="talent.favourite">
        <div class="matches-item__header">
          <a
            (click)="onTalentClick($event, talent)"
            target="_blank"
            class="matches-item__header-col matches-item__avatar"
          >
            <nz-avatar
              class="mh-avatar"
              [nzSrc]="talent.avatarUrl"
              [class.mh-avatar--male]="talent.gender?.value === 2"
              [nzSize]="84"
            ></nz-avatar>
            <div class="matches-item__status">
              <ng-container
                *ngTemplateOutlet="
                  talent.status?.includes(MatchedTalentStatus.ARCHIVED)
                    ? statusArchived
                    : talent.status?.includes(MatchedTalentStatus.REJECTED)
                    ? statusRejected
                    : talent.status?.includes(MatchedTalentStatus.CLOSED)
                    ? statusClosed
                    : talent.status?.includes(MatchedTalentStatus.IN_COMMUNICATION)
                    ? statusInCommunication
                    : talent.status?.includes(MatchedTalentStatus.UNSEEN)
                    ? statusUnseen
                    : null
                "
              ></ng-container>
              <ng-template #statusUnseen>
                <button
                  nz-button
                  nzType="link"
                  nzSize="small"
                  [nzTooltipTitle]="'job-offer-matches.status.unseen' | translate"
                  nzTooltipPlacement="top"
                  nz-tooltip
                >
                  <span nz-icon nzType="eye-invisible" nzTheme="outline"></span>
                </button>
              </ng-template>

              <ng-template #statusInCommunication>
                <button
                  nz-button
                  nzType="link"
                  nzSize="small"
                  [nzTooltipTitle]="'job-offer-matches.status.in-communication' | translate"
                  nzTooltipPlacement="top"
                  nz-tooltip
                >
                  <span nz-icon nzType="message" nzTheme="outline"></span>
                </button>
              </ng-template>

              <ng-template #statusClosed>
                <button
                  nz-button
                  nzType="link"
                  nzSize="small"
                  [nzTooltipTitle]="'job-offer-matches.status.closed' | translate"
                  nzTooltipPlacement="top"
                  nz-tooltip
                >
                  <span nz-icon nzType="check" nzTheme="outline"></span>
                </button>
              </ng-template>

              <ng-template #statusRejected>
                <button
                  nz-button
                  nzType="link"
                  nzSize="small"
                  [nzTooltipTitle]="'job-offer-matches.status.rejected' | translate"
                  nzTooltipPlacement="top"
                  nz-tooltip
                >
                  <span nz-icon nzType="close" nzTheme="outline"></span>
                </button>
              </ng-template>

              <ng-template #statusArchived>
                <button
                  nz-button
                  nzType="link"
                  nzSize="small"
                  [nzTooltipTitle]="'archived.label' | translate"
                  nzTooltipPlacement="top"
                  nz-tooltip
                >
                  <span nz-icon nzType="stop" nzTheme="outline"></span>
                </button>
              </ng-template>
            </div>
          </a>
          <div class="matches-item__header-col" style="display: flex; flex-direction: column; justify-content: center; min-height: 84px;">
            <div *ngIf="!isNameHidden(talent)" class="matches-item__name">
              <a (click)="onTalentClick($event, talent)" target="_blank">
                {{ talent.salutation }} {{ talent.firstName }} {{ talent.lastName }}
              </a>
              <a *ngIf="talent.crossRegistered" [href]="appConfig.crossPlatformUrl + '/admin/talent-view/' + (talent.crossRegisteredAccountId || talent.accountId)" target="_blank" (click)="$event.stopPropagation()">
                <img
                  class="cross-registered-logo"
                  [class.cross-registered-logo--flextalent]="appConfig.brand === 'flextalent'"
                  src="/assets/images/logo-cross-registered.svg"
                  alt="Cross registered"
                />
              </a>
            </div>
            <div *ngIf="talent.jobTitle" class="matches-item__job-title">
              {{ talent.jobTitle }}
            </div>
            <div *ngIf="isMobile">
              <ng-container *ngTemplateOutlet="salaryTemplate; context: { talent: talent }"></ng-container>
            </div>
            <div class="matches-item__info-row">
              <div *ngIf="talent.locationCity" class="matches-item__info-value">
                <div class="matches-item__info-value-body">
                  <span
                    *ngIf="talent.locationMatch"
                    nz-icon
                    [nzType]="'check-circle'"
                    [nzTheme]="'twotone'"
                    [nzTwotoneColor]="'#52c41a'"
                  ></span>
                  <div class="location">
                    <span *ngIf="talent.locationPostalCode" class="location__value">{{
                      talent.locationPostalCode
                    }}</span>
                    <span *ngIf="talent.locationCity" class="location__value">{{ talent.locationCity }}</span>
                    <span *ngIf="talent.radius" class="location__value">+{{ talent.radius.name | translate }} km</span>
                    <span *ngIf="talent.locationCountry" class="location__value">{{ talent.locationCountry }} </span>
                  </div>
                </div>
              </div>
              <div *ngIf="talent.workExperience !== null" class="matches-item__info-value nowrap">
                <div class="matches-item__info-value-body">
                  <span
                    *ngIf="talent.workExperienceMatch"
                    nz-icon
                    [nzType]="'check-circle'"
                    [nzTheme]="'twotone'"
                    [nzTwotoneColor]="'#52c41a'"
                  ></span>
                  {{ "job-offer-matches.list.work-experience.title" | translate }}
                  {{ talent.workExperience }}
                  {{ (talent.workExperience === 1 ? "year.label" : "years.label") | translate }}
                </div>
              </div>
              <div *ngIf="talent.leadershipExperience !== null" class="matches-item__info-value nowrap">
                <div class="matches-item__info-value-body">
                  <span
                    *ngIf="talent.leadershipExperienceMatch"
                    nz-icon
                    [nzType]="'check-circle'"
                    [nzTheme]="'twotone'"
                    [nzTwotoneColor]="'#52c41a'"
                  ></span>
                  {{ "job-offer-matches.list.leadership-experience.title" | translate }}
                  {{ talent.leadershipExperience }}
                  {{ (talent.leadershipExperience === 1 ? "year.label" : "years.label") | translate }}
                </div>
              </div>
              <div *ngIf="talent.leadershipTeamSize !== null" class="matches-item__info-value nowrap">
                <div class="matches-item__info-value-body">
                  <span
                    *ngIf="talent.leadershipTeamSizeMatch"
                    nz-icon
                    [nzType]="'check-circle'"
                    [nzTheme]="'twotone'"
                    [nzTwotoneColor]="'#52c41a'"
                  ></span>
                  {{ "job-offer-matches.detail.leadership-team-size.label" | translate }}
                  {{ talent.leadershipTeamSize }}
                </div>
              </div>
              <div class="matches-item__info-value nowrap">
                <div class="matches-item__info-value-body">
                  {{ "job-offer-matches.detail.job-sharing.label" | translate }}
                  {{
                    (jobOffer.jobSharing
                      ? "job-offer-matches.detail.job-sharing.true"
                      : "job-offer-matches.detail.job-sharing.false"
                    ) | translate
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="matches-item__header-col matches-item__header-col--right">
            <div *ngIf="!isMobile">
              <ng-container *ngTemplateOutlet="salaryTemplate; context: { talent: talent }"></ng-container>
            </div>

            <ng-template #salaryTemplate let-talent="talent">
              <div class="matches-item__salary nowrap">
                <span
                  *ngIf="talent.salaryExpectationMatch"
                  class="matches-item__salary-check"
                  nz-icon
                  [nzType]="'check-circle'"
                  [nzTheme]="'twotone'"
                  [nzTwotoneColor]="'#52c41a'"
                ></span>
                <span class="matches-item__salary-value">
                  {{ talent.salaryExpectations?.min?.name }} - {{ talent.salaryExpectations?.max?.name }}
                </span>
              </div>
            </ng-template>

            <div class="matches-item__score">
              <span class="matches-item__score-label">
                {{ "job-offer-matches.list.score.title" | translate }}
              </span>
              <span class="matches-item__score-value">
                {{ talent?.score }}
              </span>
            </div>
          </div>
        </div>
        <div class="matches-item__body">
          <!-- mom skills -->
          <div class="matches-item__body-item" *ngIf="appConfig.featureStatus.talentProfileShowMomSkills">
            <div class="matches-item__label">
              {{ "profile.mom-skills.title" | translate }}
            </div>
            <div class="matches-item__value">
              <mh-tags-output [value]="talent.momSkills"></mh-tags-output>
            </div>
          </div>
          <!-- / mom skills -->
          <!-- domain-expertise -->
          <div class="matches-item__body-item">
            <div class="matches-item__label">
              <div>
                {{ "job-offer-matches.list.domain-expertise.title" | translate }}
              </div>
            </div>
            <div
              *ngIf="talent.domainExpertiseMatch?.length || talent.domainExpertiseOther?.length; else noValueSpecified"
              class="matches-item__value"
            >
              <mh-tags-output
                [value]="talent.domainExpertiseMatch"
                [placeholder]="''"
                [nzColor]="'#DAF4E1'"
              ></mh-tags-output>
              <mh-tags-output [value]="talent.domainExpertiseOther" [placeholder]="''"></mh-tags-output>
            </div>
          </div>
          <!-- / domain-expertise -->
          <!-- department -->
          <div class="matches-item__body-item">
            <div class="matches-item__label">
              <div>
                {{ "job-offer-matches.detail.department.label" | translate }}
              </div>
            </div>
            <div
              *ngIf="talent.departmentMatch?.length || talent.departmentOther?.length; else noValueSpecified"
              class="matches-item__value"
            >
              <mh-tags-output
                [value]="talent.departmentMatch"
                [placeholder]="''"
                [nzColor]="'#DAF4E1'"
              ></mh-tags-output>
              <mh-tags-output [value]="talent.departmentOther" [placeholder]="''"></mh-tags-output>
            </div>
          </div>
          <!-- / department -->
          <!-- career level -->
          <div class="matches-item__body-item">
            <div class="matches-item__label">
              <div>
                {{ "profile.career-level.label" | translate }}
              </div>
            </div>
            <div *ngIf="talent.careerLevel; else noValueSpecified" class="matches-item__value">
              <nz-tag [nzColor]="talent.careerLevelMatch ? '#DAF4E1' : ''">
                {{ talent.careerLevel.name | translate }}
              </nz-tag>
            </div>
          </div>
          <!-- / career level -->
          <!-- degree -->
          <div class="matches-item__body-item">
            <div class="matches-item__label">
              <div>
                {{ "profile.degree.label" | translate }}
              </div>
            </div>
            <div *ngIf="talent.degree; else noValueSpecified" class="matches-item__value">
              <nz-tag [nzColor]="talent.degreeMatch ? '#DAF4E1' : ''">
                {{ talent.degree.name | translate }}
              </nz-tag>
            </div>
          </div>
          <!-- / degree -->
          <!-- industries -->
          <div class="matches-item__body-item">
            <div class="matches-item__label">
              <div>
                {{ "job-offer-matches.list.industries.title" | translate }}
              </div>
            </div>
            <div
              *ngIf="talent.industriesMatch?.length || talent.industriesOther?.length; else noValueSpecified"
              class="matches-item__value"
            >
              <mh-tags-output
                [value]="talent.industriesMatch"
                [placeholder]="''"
                [nzColor]="'#DAF4E1'"
              ></mh-tags-output>
              <mh-tags-output [value]="talent.industriesOther" [placeholder]="''"></mh-tags-output>
            </div>
          </div>
          <!-- / industries -->
          <!-- sectors -->
          <div class="matches-item__body-item">
            <div class="matches-item__label">
              <div>
                {{ "job-offer-matches.detail.sector.label" | translate }}
              </div>
            </div>
            <div
              *ngIf="talent.sectorsMatch?.length || talent.sectorsOther?.length; else noValueSpecified"
              class="matches-item__value"
            >
              <mh-tags-output
                [value]="talent.sectorsMatch"
                [placeholder]="''"
                [nzColor]="'#DAF4E1'"
              ></mh-tags-output>
              <mh-tags-output [value]="talent.sectorsOther" [placeholder]="''"></mh-tags-output>
            </div>
          </div>
          <!-- / sectors -->
          <!-- hashtags -->
          <div class="matches-item__body-item">
            <div class="matches-item__label">
              {{ "profile-preview.willing-change.change-date.label" | translate }}
            </div>
            <div *ngIf="talent?.changeDate as changeDate; else noValueSpecified" class="matches-item__value">
              {{ changeDate.name | translate }}
            </div>
          </div>
          <!-- / hashtags -->
          <!-- willingness to travel -->
          <div class="matches-item__body-item">
            <div class="matches-item__label">
              {{ "profile.travel-willingness.label" | translate }}
            </div>
            <div *ngIf="talent.willingnessToTravel !== null; else noValueSpecified" class="matches-item__value">
              {{ talent.willingnessToTravel }}
            </div>
          </div>
          <!-- / willingness to travel -->
          <!-- ideal working assignments -->
          <div class="matches-item__body-item">
            <div class="matches-item__label">
              <div>
                {{ "profile.ideal-local-assignments.label" | translate }}
              </div>
            </div>
            <div
              *ngIf="talent.idealWorkingAssignmentsMatch?.length || talent.idealWorkingAssignmentsOther?.length; else noValueSpecified"
              class="matches-item__value"
            >
              <mh-tags-output
                [value]="talent.idealWorkingAssignmentsMatch"
                [placeholder]="''"
                [nzColor]="'#DAF4E1'"
              ></mh-tags-output>
              <mh-tags-output [value]="talent.idealWorkingAssignmentsOther" [placeholder]="''"></mh-tags-output>
            </div>
          </div>
          <!-- / ideal working assignments -->
        </div>

        <div class="matches-item__actions nowrap">
          <nz-select
            *ngIf="
              viewerAccountType === AccountType.ADMIN ||
              viewerAccountType === AccountType.ADMIN_TALENT_MANAGER ||
              viewerAccountType === AccountType.ADMIN_SALES_MANAGER
            "
            nzShowSearch
            nzAllowClear
            [nzPlaceHolder]="'admin.stage.placeholder' | translate"
            [ngModel]="talent.stage"
            (ngModelChange)="onSetTalentStage(talent, $event || 0)"
            style="width: 200px"
          >
            <nz-option
              *ngFor="let stage of talentStages"
              [nzLabel]="stage.name | translate"
              [nzValue]="stage.value"
            ></nz-option>
          </nz-select>

          <button
            *ngIf="talent.handpicked"
            nz-button
            nzSize="large"
            nzType="link"
            [nzTooltipTitle]="'job-offer-matches.action.manual-match' | translate"
            nzTooltipPlacement="top"
            nz-tooltip
            style="margin-right: -6px; margin-left: 6px"
          >
            <span nz-icon style="transform: scale(1.3)">
              <svg viewBox="0 0 512 512">
                <g transform="translate(0,512) scale(0.1,-0.1)" fill="currentColor" stroke="none">
                  <path
                    d="M3840 4010 c-157 -38 -347 -84 -423 -103 l-138 -34 -467 94 c-598 120 -649 122 -847 23 l-80 -40 -245 -2 -245 -3 -58 -29 c-91 -46 -162 -134 -200 -247 -3 -9 -72 -54 -154 -100 -218 -124 -321 -229 -388 -396 -13 -32 -62 -238 -110 -458 -92 -425 -96 -464 -60 -536 39 -78 109 -128 218 -159 58 -16 59 -17 77 -69 9 -28 31 -69 47 -89 36 -46 112 -98 161 -112 93 -25 212 -3 287 55 19 14 62 62 96 106 33 44 62 79 64 77 1 -2 31 -70 65 -153 72 -171 104 -223 163 -267 184 -134 430 -77 533 124 22 42 28 71 32 138 l4 85 -118 330 -119 330 0 95 c0 84 3 101 28 150 39 76 108 143 181 177 53 24 73 28 151 28 76 0 99 -4 145 -26 67 -31 225 -162 264 -217 89 -129 88 -295 -4 -515 -46 -111 -109 -199 -235 -327 -70 -72 -122 -135 -139 -167 -33 -66 -56 -154 -56 -213 1 -73 26 -195 53 -254 72 -157 260 -257 428 -227 147 25 238 98 319 251 85 161 201 271 343 324 34 13 119 35 188 49 151 31 228 56 333 108 151 75 285 186 386 321 40 52 81 93 119 119 124 83 230 225 277 374 63 200 55 533 -21 815 -47 174 -140 380 -222 493 -65 88 -186 148 -296 146 -29 0 -180 -31 -337 -69z m405 -101 c62 -17 115 -80 183 -221 92 -189 141 -358 163 -563 13 -127 6 -319 -16 -414 -33 -137 -129 -269 -253 -346 -43 -26 -72 -54 -106 -105 -137 -201 -372 -349 -623 -395 -334 -61 -522 -188 -655 -443 -57 -109 -70 -124 -130 -157 -120 -67 -274 -19 -338 105 -24 48 -44 172 -35 228 12 80 43 127 164 250 129 131 199 233 257 375 93 229 98 438 13 598 -48 90 -231 260 -340 315 -251 127 -576 19 -702 -233 -46 -94 -61 -167 -54 -273 4 -77 16 -117 122 -414 109 -305 117 -333 113 -387 -3 -46 -11 -67 -34 -96 -40 -51 -96 -77 -159 -77 -57 1 -98 19 -137 61 -17 18 -105 214 -249 553 -221 523 -222 525 -226 611 -9 150 -13 144 420 576 382 381 409 404 514 432 92 25 165 16 661 -84 l481 -96 328 80 c599 146 566 140 638 120z m-2525 -122 c0 -1 -119 -121 -265 -267 l-265 -265 20 70 c11 39 37 130 57 203 43 157 73 210 134 240 39 19 61 22 182 22 75 0 137 -1 137 -3z m-823 -986 c-114 -406 -177 -617 -188 -624 -12 -7 -31 -3 -71 15 -95 44 -95 28 1 476 45 211 91 409 102 438 30 80 95 171 158 220 61 48 165 107 168 96 2 -4 -75 -283 -170 -621z m292 -370 l111 -264 -25 -36 c-67 -96 -144 -188 -175 -209 -29 -20 -44 -23 -93 -20 -46 4 -63 10 -88 34 -34 32 -59 81 -59 116 0 13 38 158 84 323 46 165 90 320 96 345 l13 45 12 -35 c7 -19 63 -154 124 -299z"
                  />
                </g>
              </svg>
            </span>
          </button>

          <button
            *ngIf="talent.favourite"
            nz-button
            nzSize="large"
            nzType="link"
            [nzTooltipTitle]="'job-offer-matches.favourite.tooltip' | translate"
            nzTooltipPlacement="top"
            nz-tooltip
            (click)="onSetTalentFavourite(talent, $event)"
          >
            <span nz-icon nzType="star" [nzTheme]="'fill'"></span>
          </button>
          <button
            *ngIf="!talent.favourite"
            nz-button
            nzSize="large"
            nzType="link"
            [nzTooltipTitle]="'job-offer-matches.favourite.tooltip' | translate"
            nzTooltipPlacement="top"
            nz-tooltip
            (click)="onSetTalentFavourite(talent, $event)"
          >
            <span nz-icon nzType="star" [nzTheme]="'outline'"></span>
          </button>

          <button
            *ngIf="!talent.status?.includes(MatchedTalentStatus.ARCHIVED)"
            nz-button
            nzSize="large"
            nzType="link"
            [nzTooltipTitle]="'job-offer-matches.action.archive' | translate"
            nzTooltipPlacement="top"
            nz-tooltip
            (click)="onArchive(talent, $event)"
          >
            <span nz-icon nzType="container" nzTheme="outline"></span>
          </button>
          <button
            *ngIf="talent.status?.includes(MatchedTalentStatus.ARCHIVED)"
            nz-button
            nzSize="large"
            nzType="link"
            [nzTooltipTitle]="'job-offer-matches.action.un-archive' | translate"
            nzTooltipPlacement="top"
            nz-tooltip
            (click)="onUnArchive(talent, $event)"
          >
            <span nz-icon nzType="container" nzTheme="fill"></span>
          </button>

          <button
            nz-button
            nzSize="large"
            nzType="link"
            [nzTooltipTitle]="'admin.comment.tooltip' | translate"
            nzTooltipPlacement="top"
            nz-tooltip
            (click)="onOpenCommentModal(talent, $event)"
          >
            <span
              nz-icon
              nzType="message"
              [nzTheme]="talent.hasComments ? 'fill' : 'outline'"
              [class.comment-icon--active]="talent.hasComments"
            ></span>
          </button>

          <ng-container *ngIf="viewerAccountType === AccountType.MISSION_PARTNER">
            <ng-container
              *ngTemplateOutlet="
                talent.status?.includes(MatchedTalentStatus.IN_COMMUNICATION) ? toConversation : startConversation
              "
            ></ng-container>
            <ng-template #toConversation>
              <button
                [disabled]="!hasReviewedStatus || !hasSelfServiceStatus"
                nz-button
                nzSize="large"
                nzType="link"
                [nzTooltipTitle]="'job-offer-matches.action.to-communication' | translate"
                nzTooltipPlacement="top"
                nz-tooltip
                (click)="onToConversation(talent, $event)"
              >
                <span nz-icon nzType="send" nzTheme="outline"></span>
              </button>
            </ng-template>

            <ng-template #startConversation>
              <button
                [disabled]="!hasReviewedStatus || !hasSelfServiceStatus"
                nz-button
                nzSize="large"
                nzType="link"
                [nzTooltipTitle]="'job-offer-matches.action.start-communication' | translate"
                nzTooltipPlacement="top"
                nz-tooltip
                (click)="onStartConversation(talent, $event)"
              >
                <span nz-icon nzType="send" nzTheme="outline"></span>
              </button>
            </ng-template>
          </ng-container>

          <ng-container
            *ngIf="
              viewerAccountType === AccountType.ADMIN ||
              viewerAccountType === AccountType.ADMIN_TALENT_MANAGER ||
              viewerAccountType === AccountType.ADMIN_SALES_MANAGER
            "
          >
            <ng-container
              *ngTemplateOutlet="
                talent.status?.includes(MatchedTalentStatus.IN_COMMUNICATION) ? toConversation : startConversation
              "
            ></ng-container>
            <ng-template #toConversation>
              <button
                nz-button
                nzSize="large"
                nzType="link"
                [nzTooltipTitle]="'job-offer-matches.action.to-communication' | translate"
                nzTooltipPlacement="top"
                nz-tooltip
                (click)="onToConversationAsAdmin(talent, $event)"
              >
                <span nz-icon nzType="send" nzTheme="outline"></span>
              </button>
            </ng-template>

            <ng-template #startConversation>
              <button
                nz-button
                nzSize="large"
                nzType="link"
                [nzTooltipTitle]="'job-offer-matches.action.start-communication' | translate"
                nzTooltipPlacement="top"
                nz-tooltip
                (click)="onStartConversationAsAdmin(talent, $event)"
              >
                <span nz-icon nzType="send" nzTheme="outline"></span>
              </button>
            </ng-template>
          </ng-container>

          <button
            nz-button
            nzSize="default"
            class="open-profile-btn"
            (click)="onTalentClick($event, talent)"
          >
            {{ 'job-offer-matches.action.open-profile' | translate }}
          </button>
        </div>
      </div>

      <nz-pagination
        class="matches-list__pagination"
        [nzTotal]="matches?.paging?.items || 0"
        [nzPageSize]="matches?.paging?.itemsOnPage || 0"
        [nzPageIndex]="matches?.paging?.page || 0"
        [nzShowTotal]="rangeTemplate"
        nzShowSizeChanger
        nzSize="small"
        (nzPageIndexChange)="onPageIndexChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
      ></nz-pagination>

      <nz-empty *ngIf="!matches.items?.length && !loading" nzNotFoundImage="simple"></nz-empty>
    </div>
  </nz-spin>
</div>

<ng-template #rangeTemplate let-range="range" let-total>
  {{ range[0] }}-{{ range[1] }} {{ "of.label" | translate }} {{ total }} items
</ng-template>

<ng-template #noValueSpecified>-</ng-template>
